import { memo } from 'react'

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography
} from '@mui/material'
import DeleteOutlineIcon from '@mui/icons-material/Delete'
import CloseIcon from '@mui/icons-material/Close'
import { useStores } from 'stores/utils/hooks/useStores'

const DeleteDebtorDialog = ({
  showDeleteModal = false,
  hideDeleteModal = () => {}
}) => {
  const {
    traversal: { handlePathFormFieldChange }
  } = useStores()
  return (
    <>
      <Dialog
        open={showDeleteModal}
        aria-labelledby="config-loader-modal"
        sx={{
          overflow: 'auto',
          '& .MuiPaper-root': {
            borderRadius: '8px' // or any value you like
          }
        }}
      >
        <DialogTitle>
          <Typography variant="h4">2. Kreditnehmer entfernen?</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography>
            Sind Sie sicher, dass Sie den zweiten Kreditnehmer entfernen wollen?
            Dieser Schritt kann nicht rückgängig gemacht werden.
          </Typography>
          <Box
            sx={{
              textAalign: 'left',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '16px',
              marginTop: '16px'
            }}
          >
            <IconButton
              color="error"
              disableRipple
              sx={{
                padding: 0,
                '&:hover': {
                  color: '#6D1C1C' // dark red or custom hover color
                },
                '&:hover .hover-text': {
                  color: '#6D1C1C'
                }
              }}
              onClick={() =>
                handlePathFormFieldChange(`debtors.count`, 1, false)
              }
            >
              <DeleteOutlineIcon />
              <Typography
                className="hover-text"
                variant="body2"
                color="error"
                fontWeight={700}
              >
                Kreditnehmer entfernen
              </Typography>
            </IconButton>
            <IconButton
              disableRipple
              sx={{
                padding: 0,
                '&:hover': {
                  color: '#848484' // dark red or custom hover color
                },
                '&:hover .hover-text': {
                  color: '#848484'
                }
              }}
              onClick={hideDeleteModal}
            >
              <CloseIcon />
              <Typography
                className="hover-text"
                variant="body2"
                fontWeight={700}
              >
                Abbrechen
              </Typography>
            </IconButton>
          </Box>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default memo(DeleteDebtorDialog)
